import { LinkProps } from 'react-router-dom'
import { NavLink } from './Elements'

type Props = {
  onNavLinkClick: () => void
  LinkComponent: React.FC<LinkProps> | typeof NavLink
  InactiveLinkComponent: React.FC<LinkProps> | typeof NavLink
  shouldShowReports?: boolean
}

const UmcNav: React.FC<Props> = ({
  onNavLinkClick,
  LinkComponent,
  InactiveLinkComponent,
  shouldShowReports = false,
}) => {
  return (
    <>
      <LinkComponent onClick={onNavLinkClick} to="/customers">
        Customers
      </LinkComponent>
      {shouldShowReports && (
        <LinkComponent to="/customer-reports" onClick={onNavLinkClick}>
          Reports
        </LinkComponent>
      )}
      <InactiveLinkComponent
        to="/taxes"
        disabled
        title="Coming soon"
        onClick={(e: React.MouseEvent<HTMLAnchorElement>): void => {
          e.preventDefault()
        }}
      >
        Taxes
      </InactiveLinkComponent>
    </>
  )
}

export default UmcNav
